const easternCalendar = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/New_York", month: "numeric", day: "numeric",
});

export function isHalloweenBrandActive(now = new Date()): boolean {
  const parts = easternCalendar.formatToParts(now);
  const month = Number(parts.find((part) => part.type === "month")?.value);
  const day = Number(parts.find((part) => part.type === "day")?.value);
  return month === 10 && day >= 16 && day <= 31;
}

export function customerBrandColor(color: string, now = new Date()): string {
  if (!isHalloweenBrandActive(now)) return color;
  const palette: Record<string, string> = {
    "#c00000": "#b93800",
    "#ffd700": "#ffb703",
    "#ffd400": "#ffb703",
    "#111827": "#160b20",
    "#fef2f2": "#fff4e8",
    "#fee2e2": "#ffe3c6",
    "#f3b1b1": "#e6b6ef",
  };
  return palette[color.toLowerCase()] || color;
}

export function customerBrandLogo(now = new Date()): string {
  return isHalloweenBrandActive(now)
    ? "/seasonal/halloween/grade-a-halloween-logo.png"
    : "/grade-a-hero-logo.png?v=transparent-20261010";
}

export const REGULAR_SOCIAL_IMAGE = "/og-image.png?v=7";
export const HALLOWEEN_SOCIAL_IMAGE = "/seasonal/halloween/og-image.png?v=1";

export function customerBrandSocialImage(now = new Date()): string {
  return isHalloweenBrandActive(now) ? HALLOWEEN_SOCIAL_IMAGE : REGULAR_SOCIAL_IMAGE;
}
